import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Helmet from 'react-helmet';

import Textlink from '@xingternal/malt-textlink';
import { AdProvider, SkyscraperAd } from '@xingternal/adprovider';
import { Row, Column } from '@xingternal/malt-grid';

import parseQueryString from './../../utils/parseQueryString';
import PageviewTracker from '../../Components/PageviewTracker/PageviewTracker';
import Spacer from './../../Components/Spacer/Spacer';
import { CustomH, CustomP } from './../../Components/CustomMalt/Typography';

import messages from './messages';
import styles from './Logout.css';

const buildLink = (to, message) => (
  <Textlink testId={'login-again-link'} to={to}>
    <FormattedMessage {...message} />
  </Textlink>
);

export const timeToGreetingKey = () => {
  const now = new Date();
  const greetingsDictionary = [
    {
      hours: [2, 3, 4, 5, 6, 7, 8],
      messageKey: 'morningHeadline',
    },
    {
      hours: [9, 10, 11, 12, 13, 14, 15, 16, 17],
      messageKey: 'dayHeadline',
    },
    {
      hours: [18, 19, 20, 21, 22, 23, 0, 1],
      messageKey: 'nightHeadline',
    },
  ];

  const { messageKey } = greetingsDictionary.find(({ hours }) =>
    hours.includes(now.getHours())
  );

  return messageKey;
};

/**
 * We expect the query string to have a param 'kvp'
 * (key-value pairs) that has additional tracking values.
 * The key-value pairs are separated by semicolons.
 */
export const flattenTrackingParams = ({ kvp, ...params } = {}) => {
  if (!kvp) return { ...params };
  const objectifiedKvp = kvp
    .split(';')
    .map(string => {
      const [key, value] = string.split('=');
      return { [key]: value };
    })
    .reduce((prev, curr) => ({ ...prev, ...curr }), {});
  return { ...params, ...objectifiedKvp };
};

const Logout = ({ location, intl }) => {
  const adParams = flattenTrackingParams(parseQueryString(location.search));

  return (
    <>
      <Helmet title={intl.formatMessage(messages.metaTitle)} />
      <PageviewTracker pageName={'wbm/Welcome/logout'} />
      <Spacer size={8} />
      <Row style={{ height: '75vh' }}>
        <Column
          sizeDesktop={9}
          sizeTablet={12}
          size={12}
          className={styles.centerChildren}
        >
          <CustomH>
            <FormattedMessage {...messages[timeToGreetingKey()]} />
          </CustomH>
          <CustomP>
            <FormattedMessage
              {...messages.comeback}
              values={{
                loginLink: buildLink('/', messages.loginLinkText),
              }}
            />
          </CustomP>
        </Column>
        <Column sizeDesktop={3} sizeTablet={0} size={0}>
          <AdProvider logoutAd logoutTracking={adParams || {}}>
            <SkyscraperAd id={'89'} reloading nofence />
          </AdProvider>
        </Column>
      </Row>
    </>
  );
};

export default injectIntl(Logout);
